"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataEvent = void 0;
const abstract_event_1 = require("../abstract.event");
class UserDataEvent extends abstract_event_1.AbstractEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'user_data_update';
    }
    getData() {
        return Object.assign({ id: this.config.id, shop_id: this.config.shop_id, email: this.config.email, firstname: this.config.firstname, lastname: this.config.lastname, dateOfBirth: this.config.dateOfBirth, phone: this.config.phone }, (this.config.eventId ? { eventId: this.config.eventId } : {}));
    }
}
exports.UserDataEvent = UserDataEvent;
//# sourceMappingURL=user-data.event.js.map